import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";

import DataTable from "../../../../../components/DataTable";

export default function LookupTable({ formikProps }) {
  const options = {
    sortOrder: {
      name: "name",
      direction: "asc",
    },
    filter: false,
    download: false,
    viewColumns: false,
    search: false,
    print: false,
  };

  function handleDelete(index) {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      entityLookups: setRegex(prevVal.entityLookups),
    }));

    function setRegex(entityLookups) {
      var re = [...entityLookups];
      return re.filter((r) => r.lookup !== re[index.rowIndex].lookup, 1);
    }
  }

  const columns = [
    {
      name: "lookup",
      label: "Lookups",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Not Available";
        },
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (_, index) => (
          <React.Fragment>
            <Tooltip title="Delete Regex">
              <IconButton
                style={{ color: "#ff0000" }}
                onClick={() => handleDelete(index)}
                size="small"
              >
                <DeleteOutline />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        ),
      },
    },
  ];

  return (
    <React.Fragment>
      <DataTable
        columns={columns}
        options={options}
        data={formikProps.values.entityLookups}
      />
    </React.Fragment>
  );
}
